import { render, staticRenderFns } from "./FirmDocuments.vue?vue&type=template&id=2344dd76"
import script from "./FirmDocuments.vue?vue&type=script&lang=js"
export * from "./FirmDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports